import { Navigate, Route, Routes } from "react-router-dom";
import { ForgotPassword, ResetPassword, SignIn } from "components/organisms";

const AuthFlow = (props: any): JSX.Element => {
	const { authState } = props;

	if (authState !== "signIn") {
		return <></>;
	}

	return (
		<Routes>
			<Route index element={<SignIn />} />
			<Route path="/forgot-password" element={<ForgotPassword />} />
			<Route path="/reset-password" element={<ResetPassword />} />
			<Route path="*" element={<Navigate to="/" replace />} />
		</Routes>
	);
};

export default AuthFlow;
